import { render, staticRenderFns } from "./CardTablero.vue?vue&type=template&id=dac62044&scoped=true&"
import script from "./CardTablero.vue?vue&type=script&lang=js&"
export * from "./CardTablero.vue?vue&type=script&lang=js&"
import style0 from "./CardTablero.vue?vue&type=style&index=0&id=dac62044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac62044",
  null
  
)

export default component.exports